// Lightweight dataLayer helper for GTM.
// GTM (loaded in public/index.html) initializes window.dataLayer; this helper
// safely pushes events even before GTM finishes loading (they get queued).
// Usage: track('event_name', { any: 'params' })

export const track = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};
